import { render, staticRenderFns } from "./EventsValidationCarousel.vue?vue&type=template&id=4917e146"
import script from "./EventsValidationCarousel.vue?vue&type=script&lang=ts"
export * from "./EventsValidationCarousel.vue?vue&type=script&lang=ts"
import style0 from "./EventsValidationCarousel.vue?vue&type=style&index=0&id=4917e146&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports